module.exports = __webpack_public_path__ + "img/FullWidthCta.83610980.png";